import { QRErrors } from './getQRScannerError';

// see: https://github.com/zxing-js/ngx-scanner/blob/e08c6bfbbd714dfc6a86b1304fbe9b680ea9ae46/projects/zxing-scanner/src/lib/zxing-scanner.component.ts
export function isCameraUnvailable(err: DOMException): boolean {
  const unvailableErrors = Object.values<string>(QRErrors);
  return unvailableErrors.includes(err.name);
}
